<template>
	<div class="">
		<!-- <headers bg="#000" color="#fff"></headers> -->
		<headers></headers>
		<a-spin :spinning="loading">
			<div class="row py-5 teacher-container body-height">
				<div class="col-md-7">
					<teacher-details :teacher_id="Number(teacher_id)"></teacher-details>
				</div>
				<div class="col-md">
					<appointment-window :teacher_id="Number(teacher_id)" :teacher_course_id="Number(teacher_course_id)"
					:teacherName="form.name" :teacherPhoto="form.photo_image" :testPrice="Number(form.experience_price)" :user_id="Number(form.user_id)"></appointment-window>
					<div class="ftr-1-25 ftw600">
						<!-- 我的課堂 -->
						{{$t('teacherVue.myClass')}}
					</div>
					
					<div class="flex mt-2">
						
						<div class="py-1 px-3 clickAct" v-for="(item,index) in formTeacherC"
						@click="changeClassType(item) "
						:class="formTeacherTypeId==item.id?'bg-theme border-theme cl-w':'bg-F3F3F3 border-gray'">
							{{item.name}}
						</div>
					</div>
					
					<div class="mt-2 row ft14 flex alcenter clickAct" v-for="(it,ind) in formTeacherItem" :key="ind">
						<div class="col-md-2">
							{{it.name}}
						</div>
						<div class="col-md py-2 flex wrap" >
							<div  v-for="(itChild,inChild) in it.teacherCourse">
								<div class="p-2 ml10" style="height: 40px;" v-if="itChild.is_experience=='1'">{{$t('common.experienceClass')}}</div>
								<div class="p-2 ml10" style="height: 40px;" v-else-if="itChild.is_experience=='2'">
									{{$t('teacherVue.formalClasses')}}
								</div>
								<div class="p-2 ml10" style="height: 40px;" v-else>
									
								</div>
								<div class="border-gray br8 wid-fit p-1 ml5 mt-1" style="width: 100px;height: 65px;" 
								@click="buyClass(it.id,it.name,itChild)">
									
									<div class="ftw600">
										{{getCurrency()}}{{convertCurrency(itChild.once_price)}}
									</div>
									<div class="cl-info ft10" v-if="itChild.is_experience=='2'">
										<!-- {{itChild.quantity}}堂50分鐘課 -->
										{{$t('teacherVue.formalClassTime',{number:itChild.quantity})}}
									</div>
									<div class="cl-info ft10" v-else>
										 {{$t('common.teatClasstime')}}
									</div>
									<div class="border-theme py-0 px-3 cl-theme ft10 wid-fit"
									v-if="itChild.discount!='0.00'">
										{{itChild.discount}}% off
									</div>
								</div>
							</div>
							
						</div>
					</div>
					<div class="bg-FFEBE4 p-3 br8 mt-4" v-if="showPrice">
						<div class="ftw600 ft14">
							<!-- 老師課堂價格將在 2024年6月1日05:01PM(UTC+08:00)調價 -->
							{{$t('teacherVue.priceAdjustment',{time: convertToTimeZone('2025-05-23 11:55:00').formattedTime })}}({{timeZone}})
						</div>
						<div class="mt-2 ft14">
							{{$t('teacherVue.formalClasses')}}
						</div>
						<div class="flex mt-2">
							<div class="py-1 px-2 ft14clickAct" v-for="(item,index) in formTeacherC"
							@click="formTeacherItem = item.course;formTeacherTypeId=item.id;"
							:class="formTeacherTypeId==item.id?'bg-theme border-theme cl-w':'bg-F3F3F3 border-gray'">
								{{item.name}}
							</div>
						</div>
						<div class="mt-2 row ft14 flex alcenter" v-for="(it,ind) in formTeacherItem" :key="ind">
							<div class="col-md-3">
								{{it.name}}
							</div>
							<div class="col-md py-2 flex wrap">
								<div class="border-gray bg-w br8 wid-fit p-1 ml5" style="width: 100px;" v-for="itChild in it.teacherCourseDelay">
									<div class="ftw600">
										{{getCurrency()}}{{convertCurrency(itChild.once_price)}}
									</div>
									<div class="cl-info ft10">
										<!-- {{itChild.quantity}}堂50分鐘課 -->
										{{$t('teacherVue.formalClassTime',{number:itChild.quantity})}}
									</div>
									<div class="border-theme py-0 px-3 cl-theme ft10 wid-fit">
										{{itChild.discount}}% off
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</a-spin>
		
		<footers></footers>
	</div>
</template>

<script>
	import teacherDetails from "../../components/teacher/teacherDetails.vue"
	import appointmentWindow from "../../components/appointmentWindow.vue"
	export default{
		components:{
			teacherDetails,
			appointmentWindow
		},
		data(){
			return{
				teacher_id:0,
				form:{},
				formTeacherC:[],
				formTeacherTypeId:0,
				formTeacherTypeName:'',
				formTeacherItem:{},
				formTeacherItemDelay:{},
				loading:false,
				teacher_course_id:0,
				timeZone:localStorage.getItem('timeZone'),
				showPrice:false
			}
		},
		async created(){
			this.teacher_id = this.$route.query.id
			this.loading =true
			await this.getTeacherDeatail()
			await this.getClassifyList()
			this.loading = false
		},
		methods:{
			async getTeacherDeatail(){
				await this.$http.api('teachers/teacherDeatail',{
					teacher_id:this.teacher_id
				}).then(res=>{
					this.form = res.info
				})
			},
			// 课程分类
			async getClassifyList(teacherCourse){
				await this.$http.api('course/classifyList',{
					teacherCourse:this.teacher_id,
					includeCourse:1,//返回老师课程信息
				}).then(res=>{
					this.formTeacherC=res.list
					this.formTeacherTypeId = res.list[0].id
					this.formTeacherTypeName =res.list[0].name
					this.formTeacherItem = res.list[0].course
					this.teacher_course_id = res.list[0].course[0].teacherCourse[0].id
					this.formTeacherItem.forEach((item,index)=>{
						if(item.teacherCourseDelay.length!=0){
							this.showPrice = true
						}
					})
				})
			},
			changeClassType(item){
				 this.formTeacherItem = item.course;
				 this.formTeacherTypeId=item.id;
				 this.formTeacherTypeName=item.name
				 this.showPrice = false
				 this.formTeacherItem.forEach((item,index)=>{
				 	if(item.teacherCourseDelay.length!=0){
				 		this.showPrice = true
				 	}
				 })
			},
			buyClass(id,name,item){
				this.$router.push('/cashDesk?teacherId='+this.teacher_id+'&teacherName='+this.form.name+'&teacherPhoto='+this.form.photo_image+'&test='+item.is_experience
				+'&course_id='+id+'&course_name='+name+'&course_classify_id='+this.formTeacherTypeId+'&course_classify_name='+this.formTeacherTypeName+'&item='+JSON.stringify(item)
				+'&teacher_course_id='+item.id)
				
			},
			buyClassTest(){
				this.$router.push('/cashDesk?test=1&teacherId='+this.teacher_id+'&teacherName='+this.form.name+
				'&teacherPhoto='+this.form.photo_image+'&testPrice='+this.form.experience_price+'&teacher_course_id='+this.teacher_course_id)
			}
		}
	}
</script>

<style>
	@media (max-width:575.98px) {
		.teacher-container {
			margin: auto;
			width: 95%;
		}
	
	}
	@media (min-width: 576px) {
		.teacher-container {
			margin: auto;
			width: 580px;
		}
	
	}
	
	@media (min-width: 768px) {
		.teacher-container {
			margin: auto;
			width: 900px;
		}
	}
	
	@media (min-width: 1200px) {
		.teacher-container {
			margin: auto;
			width: 1100px;
		}
	}
	
	@media (min-width: 1400px) {
		.teacher-container {
			margin: auto;
			width: 1300px;
		}
	}
	
</style>